import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { observer, inject } from "mobx-react";
import MyDetails from './MyDetails';
import MyOrders from './MyOrders';
import MyDownloads from './MyDownloads';
import ManageCarts from './ManageCarts';
import MyFavorites from './MyFavorites';
import ButtonWithLoading from '@/components/form-fields/ButtonWithLoading';
import { hexToRgba } from '@/utils/misc';
import { handleLogout } from '@/utils/auth';
const AccountTabs = inject('studioStore', 'generalSettingsStore')(observer(({ studioStore, generalSettingsStore, userData, fetchUserData, countries, activeTab: initialTab, setIsLoading, isLoading, router }) => {
  const [activeTab, setActiveTab] = useState(initialTab || 'my-details');
  const t = useTranslations('Account');
  const primaryColor = studioStore.settings.colors.primary_color;
  const container = studioStore.settings.login_register?.container;
  const containerBackgroundColor = studioStore.settings.login_register?.container_background_color;

  // Check if cart management is enabled
  const isCartManagementEnabled = generalSettingsStore.showCartManageMultiple;

  // Check if favorites feature is enabled
  const isFavoritesEnabled = generalSettingsStore.showFavorites;


  const handleLogoutClick = async () => {
    setIsLoading(true);
    try {
      await handleLogout(router);
    } catch (error) {
      console.error('Logout error:', error);
      setIsLoading(false);
    }
  };

  let classes = "";
  const style = {
    backgroundColor: containerBackgroundColor,
  };

  if (container === "stamp") {
    classes = classes + " stamp-border";
    style.backgroundImage = `radial-gradient(8px, transparent 98%, ${containerBackgroundColor}),linear-gradient(${containerBackgroundColor} 0px, ${containerBackgroundColor} 0px)`;
    style.backgroundColor = '';
  }

  const renderContent = () => {
    switch (activeTab) {
      case 'my-details':
        return <MyDetails userData={userData} refreshUserData={fetchUserData} countries={countries} />;
      case 'my-orders':
        return <MyOrders userData={userData} />;
      case 'my-downloads':
        return <MyDownloads />;
      case 'manage-carts':
        return <ManageCarts />;
      case 'my-favorites':
        return <MyFavorites />;
      default:
        return <MyDetails userData={userData} refreshUserData={fetchUserData} countries={countries} />;
    }
  };

  return (
    <div className="flex flex-wrap">
      <div className={`${classes} w-full md:w-1/4 px-6 py-12`} style={style}>
        <div className="mb-2 p-3">
          <h1 className="mb-4 text-2xl font-bold text-primary-studio font-secondary">{t('my_account')}</h1>
          <hr className="dotted-spaced my-4" />
          <p className="text-sm">{t('welcome')}, {userData.first_name ? userData.first_name : userData.username}!</p>
        </div>

        <ul className="space-y-4 p-3">
          <li>
            <button
              onClick={() => setActiveTab('my-details')}
              style={activeTab === 'my-details'
                ? { backgroundColor: primaryColor, color: 'white' }
                : { backgroundColor: hexToRgba(primaryColor, 0.1) }}
              className="block w-full p-2 transition duration-300"
              data-testid="my-details-tab"
            >
              {t('my_details')}
            </button>
          </li>
          <li>
            <button
              onClick={() => setActiveTab('my-orders')}
              style={activeTab === 'my-orders'
                ? { backgroundColor: primaryColor, color: 'white' }
                : { backgroundColor: hexToRgba(primaryColor, 0.1) }}
              className="block w-full p-2 transition duration-300"
            >
              {t('my_orders')}
            </button>
          </li>
          {isCartManagementEnabled && (
            <li>
              <button
                onClick={() => setActiveTab('manage-carts')}
                style={activeTab === 'manage-carts'
                  ? { backgroundColor: primaryColor, color: 'white' }
                  : { backgroundColor: hexToRgba(primaryColor, 0.1) }}
                className="block w-full p-2 transition duration-300"
              >
                {t('manage_carts')}
              </button>
            </li>
          )}
          {isFavoritesEnabled && (
            <li>
              <button
                onClick={() => setActiveTab('my-favorites')}
                style={activeTab === 'my-favorites'
                  ? { backgroundColor: primaryColor, color: 'white' }
                  : { backgroundColor: hexToRgba(primaryColor, 0.1) }}
                className="block w-full p-2 transition duration-300"
              >
                {t('my_favorites')}
              </button>
            </li>
          )}
          { // TODO: Digital downloads tab
          /* <li>
            <button
              onClick={() => setActiveTab('downloads')}
              className={`block w-full p-2 ${activeTab === 'downloads' ? 'bg-white font-bold' : 'bg-gray-100'}`}
            >
              {t('my_downloads')}
            </button>
          </li> */}
          <li>
            <ButtonWithLoading
              type="button"
              className="mt-4"
              onClick={handleLogoutClick}
              isLoading={isLoading}
              loadingText={t('logging_out')}
              text={t('logout')}
              outline
              variant="error"
              size="small"
              full
              data-testid="logout-button"
            />
          </li>
        </ul>
      </div>
      <div className={`${classes} w-full md:w-3/4 px-6 py-12`} style={style}>
        {renderContent()}
      </div>
    </div>
  );
}));

export default AccountTabs;
